module.exports = __webpack_public_path__ + "img/google_logo.f6ce5696.svg";